import { render, staticRenderFns } from "./admin-pickbox-games.vue?vue&type=template&id=39c8aa60&"
import script from "./admin-pickbox-games.vue?vue&type=script&lang=js&"
export * from "./admin-pickbox-games.vue?vue&type=script&lang=js&"
import style0 from "./admin-pickbox-games.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports